import { Component, ViewEncapsulation } from "@angular/core";
import { AvatarBase } from "./avatar-base";

@Component({
    selector: 'avatar[small]',
    styleUrls: ['./avatar.scss'],
    template: `
		<img *ngIf="shouldShowImage" [ngSrc]="imageUrl" width="20" height="20" (error)="onImageError()" (load)="imgLoaded()"/>
        <div class="st-avatar__initials" *ngIf="!shouldShowImage">{{initials}}</div>
        <ng-content select="[upload]"></ng-content>
	`,
    host: {
        'class': 'st-avatar'
    },
    // changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None

})
export class AvatarSmall extends AvatarBase { }


@Component({
    selector: 'avatar[horizontal-small]:not([small])',
    styleUrls: ['./avatar.scss'],
    template: `
		<img *ngIf="shouldShowImage" [ngSrc]="imageUrl" width="24" height="24" (error)="onImageError()" (load)="imgLoaded()"/>
        <div class="st-avatar__initials" *ngIf="!shouldShowImage">{{initials}}</div>
		<div class="st-avatar__name" [matTooltip]="userName">{{userName}}</div>
        <ng-content select="[upload]"></ng-content>
	`,
    host: {
        'class': 'st-avatar'
    },
    // changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None

})
export class AvatarSmallHorizontalName extends AvatarBase { }

@Component({
    selector: 'avatar[vertical-small]:not([small])',
    styleUrls: ['./avatar.scss'],
    template: `
		<img *ngIf="shouldShowImage" [ngSrc]="imageUrl" width="24" height="24" (error)="onImageError()" (load)="imgLoaded()"/>
        <div class="st-avatar__initials" *ngIf="!shouldShowImage">{{initials}}</div>
		<div class="st-avatar__name" [matTooltip]="userName">{{userName}}</div>
        <ng-content select="[upload]"></ng-content>
	`,
    host: {
        'class': 'st-avatar'
    },
    // changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None

})
export class AvatarSmallVerticalName extends AvatarBase { }
